<div class="account-details-container">
  <!-- Breadcrumb -->
  <div class="breadcrumb-section">
    <umkt-breadcrumb [items]="breadcrumbItems" [useChevronIcon]="true" (itemClick)="onBreadcrumbClick($event)"></umkt-breadcrumb>
  </div>

  <!-- Header da página -->
  <div class="page-header">
    <h1 class="page-title">{{ 'pages.accountDetails.title' | i18n }}</h1>
  </div>

  <!-- Loading state padrão -->
  <umkt-loading [size]="'lg'" [isLoading]="isLoading" [showText]="true" [text]="'pages.accountDetails.loading' | i18n" mode="overlay"></umkt-loading>

  <!-- Content -->
  <ng-container *ngIf="!isLoading">
    <ng-container *ngIf="!loadError; else errorBlock">
      <div class="account-content">
        <div class="user-info-section">
          <!-- Container 1: Dados do usuário (ocultar quando alterando senha) -->
          <div class="info-container" *ngIf="!isChangingPassword">
            <div class="form-container">
              <div class="form-header">
                <h2 class="form-title">{{ 'pages.accountDetails.userData.title' | i18n }}</h2>
              </div>
              
              <div class="form-content">
                <form [formGroup]="userDataForm" class="info-form">
                  <div class="form-vertical">
                    <div class="form-field">
                      <div class="input-group">
                        <umkt-custom-input
                          formControlName="fullName"
                          [ariaLabel]="'pages.accountDetails.userData.fullName.label' | i18n"
                          [placeholder]="'pages.accountDetails.userData.fullName.placeholder' | i18n"
                          [disabled]="!isEditingUserData"
                          [maxlength]="255"
                          (keydown)="preventLeadingSpace($event)">
                        </umkt-custom-input>
                        <div *ngIf="fullNameControl.value?.length > 255" class="field-error">{{ 'pages.accountDetails.userData.fullName.errorMax' | i18n }}</div>
                        <div *ngIf="fullNameControl.value?.length <= 255 && fullNameControl?.errors?.['invalidFullName'] && fullNameControl?.touched" class="field-error">
                          {{ 'pages.accountDetails.userData.fullName.errorInvalid' | i18n }}
                        </div>
                        <div *ngIf="fullNameControl.value?.length <= 255 && !fullNameControl?.errors?.['invalidFullName'] && fullNameControl?.errors?.['required'] && fullNameControl?.touched" class="field-error">
                          {{ 'pages.accountDetails.userData.fullName.errorRequired' | i18n }}
                        </div>
                      </div>
                    </div>
                    
                    <div class="form-field">
                      <div class="input-group">
                        <umkt-custom-input
                          formControlName="email"
                          [ariaLabel]="'pages.accountDetails.userData.email.label' | i18n"
                          [placeholder]="'pages.accountDetails.userData.email.placeholder' | i18n"
                          type="email"
                          [disabled]="!isEditingUserData"
                          [maxlength]="121">
                        </umkt-custom-input>
                        <div *ngIf="emailControl.value?.length > 120" class="field-error">{{ 'pages.accountDetails.userData.email.errorMax' | i18n }}</div>
                        <div *ngIf="emailControl.value?.length <= 120 && emailControl?.errors?.['email'] && emailControl?.touched" class="field-error">
                          {{ 'pages.accountDetails.userData.email.errorInvalid' | i18n }}
                        </div>
                        <div *ngIf="emailControl.value?.length <= 120 && !emailControl?.errors?.['email'] && emailControl?.errors?.['required'] && emailControl?.touched" class="field-error">
                          {{ 'pages.accountDetails.userData.email.errorRequired' | i18n }}
                        </div>
                      </div>
                    </div>
                    
                    <div class="form-field">
                      <div class="input-group">
                        <umkt-custom-input
                          formControlName="phone"
                          [ariaLabel]="'pages.accountDetails.userData.phone.label' | i18n"
                          [placeholder]="'pages.accountDetails.userData.phone.placeholder' | i18n"
                          type="tel"
                          [maxlength]="15"
                          (input)="applyPhoneMask($event)"
                          mask=""
                          [disabled]="!isEditingUserData">
                        </umkt-custom-input>
                        <div *ngIf="phoneControl?.errors?.['invalidPhone'] && phoneControl?.touched" class="field-error">
                          {{ 'pages.accountDetails.userData.phone.errorInvalid' | i18n }}
                        </div>
                        <div *ngIf="phoneControl?.errors?.['required'] && phoneControl?.touched" class="field-error">
                          {{ 'pages.accountDetails.userData.phone.errorRequired' | i18n }}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div class="container-actions">
                <!-- Botões no modo de edição -->
                  <ng-container *ngIf="isEditingUserData">
                    <button class="action-button cancel-button" (click)="cancelEditingUserData()">
                      {{ 'shared.buttons.cancel' | i18n }}
                    </button>
                    <button class="action-button save-button" (click)="saveUserData()"
                      [disabled]="userDataForm.invalid || hasUserDataCharLimitError() || !hasUserDataFormChanged()"
                      [ngClass]="{'disabled-btn': userDataForm.invalid || hasUserDataCharLimitError() || !hasUserDataFormChanged()}">
                      {{ 'shared.buttons.save' | i18n }}
                    </button>
                  </ng-container>

                <!-- Botões no modo normal -->
                  <ng-container *ngIf="!isEditingUserData">
                    <button class="action-button password-button" (click)="startChangingPassword()">
                      {{ 'pages.accountDetails.actions.changePassword' | i18n }}
                    </button>
                    <button class="action-button update-button" (click)="startEditingUserData()">
                      {{ 'pages.accountDetails.actions.updateData' | i18n }}
                    </button>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

        <!-- Container 2: Endereço de cobrança-->
          <div class="info-container" *ngIf="!isChangingPassword">
            <div class="form-container">
              <div class="form-header">
                <h2 class="form-title">{{ 'pages.accountDetails.address.title' | i18n }}</h2>
              </div>
              
              <div class="form-content">
                <form [formGroup]="addressForm" class="info-form">
                  <div class="form-grid">
                    <div class="form-field-dual">
                      <div class="form-field cep-field">
                        <div class="input-group">
                          <div class="cep-field-wrapper">
                            <umkt-custom-input
                              formControlName="zipCode"
                              [ariaLabel]="'pages.accountDetails.address.zipCode.label' | i18n"
                              [placeholder]="'pages.accountDetails.address.zipCode.placeholder' | i18n"
                              mask="00000-000"
                              type="tel"
                              [disabled]="!isEditingAddress"
                              [showClearButton]="true">
                            </umkt-custom-input>
                          </div>
                          <div *ngIf="zipCodeControl?.errors?.['invalidCEP'] && zipCodeControl?.touched" class="field-error">
                            {{ 'pages.accountDetails.address.zipCode.errorInvalid' | i18n }}
                          </div>
                          <div *ngIf="zipCodeControl?.errors?.['required'] && zipCodeControl?.touched" class="field-error">
                            {{ 'pages.accountDetails.address.zipCode.errorRequired' | i18n }}
                          </div>
                        </div>
                      </div>
                      
                      <div class="form-field address-field">
                        <div class="input-group">
                          <umkt-custom-input
                            formControlName="address"
                            [ariaLabel]="'pages.accountDetails.address.address.label' | i18n"
                            [placeholder]="'pages.accountDetails.address.address.placeholder' | i18n"
                            [maxlength]="255"
                            [disabled]="true"
                            (keydown)="preventLeadingSpace($event)">
                          </umkt-custom-input>
                          <div *ngIf="addressControl.value?.length > 255" class="field-error">{{ 'pages.accountDetails.address.address.errorMax' | i18n }}</div>
                          <div *ngIf="addressControl.value?.length <= 255 && addressControl?.errors?.['required'] && addressControl?.touched" class="field-error">
                            {{ 'pages.accountDetails.address.address.errorRequired' | i18n }}
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  <!-- Container para Número e Complemento na mesma linha-->
                    <div class="form-field-dual">
                      <div class="form-field number-field">
                        <div class="input-group">
                          <umkt-custom-input
                            formControlName="number"
                            [ariaLabel]="'pages.accountDetails.address.number.label' | i18n"
                            [placeholder]="'pages.accountDetails.address.number.placeholder' | i18n"
                            [maxlength]="20"
                            [disabled]="!isEditingAddress"
                            (keydown)="preventLeadingSpace($event)">
                          </umkt-custom-input>
                          <div *ngIf="numberControl?.errors?.['required'] && numberControl?.touched" class="field-error">
                            {{ 'pages.accountDetails.address.number.errorRequired' | i18n }}
                          </div>
                          <span *ngIf="numberControl.value?.length > 20" class="field-error">{{ 'pages.accountDetails.address.number.errorMax' | i18n }}</span>
                        </div>
                      </div>
                      
                      <div class="form-field complement-field">
                        <umkt-custom-input
                          formControlName="complement"
                          [ariaLabel]="'pages.accountDetails.address.complement.label' | i18n"
                          [placeholder]="'pages.accountDetails.address.complement.placeholder' | i18n"
                          [disabled]="!isEditingAddress"
                          [maxlength]="100"
                          (keydown)="preventLeadingSpace($event)">
                        </umkt-custom-input>
                        <span *ngIf="complementControl.value?.length > 100" class="field-error">{{ 'pages.accountDetails.address.complement.errorMax' | i18n }}</span>
                      </div>
                    </div>
                    
                  <!-- Container para bairro, cidade e estado na mesma linha -->
                    <div class="form-field-triple">
                      <div class="form-field">
                        <div class="input-group">
                          <umkt-custom-input
                            formControlName="neighborhood"
                            [ariaLabel]="'pages.accountDetails.address.neighborhood.label' | i18n"
                            [placeholder]="'pages.accountDetails.address.neighborhood.placeholder' | i18n"
                            [maxlength]="100"
                            [disabled]="true"
                            (keydown)="preventLeadingSpace($event)">
                          </umkt-custom-input>
                          <div *ngIf="neighborhoodControl.value?.length > 100" class="field-error">{{ 'pages.accountDetails.address.neighborhood.errorMax' | i18n }}</div>
                          <div *ngIf="neighborhoodControl.value?.length <= 100 && neighborhoodControl?.errors?.['required'] && neighborhoodControl?.touched" class="field-error">
                            {{ 'pages.accountDetails.address.neighborhood.errorRequired' | i18n }}
                          </div>
                        </div>
                      </div>
                      
                      <div class="form-field">
                        <div class="input-group state-select">
                          <select
                            formControlName="state"
                            [disabled]="!isEditingAddress || !cepError"
                            (change)="onStateChange($event)"
                            required
                            class="form-control styled-select">
                            <option *ngFor="let state of brazilStatesWithPlaceholder" [value]="state.value">
                              {{ state.label === 'Selecione o estado' ? ('pages.accountDetails.address.state.defaultOption' | i18n) : state.label }}
                            </option>
                          </select>
                          <div *ngIf="stateControl?.errors?.['required'] && stateControl?.touched" class="field-error">
                            {{ 'pages.accountDetails.address.state.errorRequired' | i18n }}
                          </div>
                        </div>
                      </div>
                      
                      <div class="form-field">
                          <div class="input-group city-input-container">
                            <umkt-custom-input
                              type="text"
                              class="input-custom"
                              [placeholder]="(selectedState ? 'pages.accountDetails.address.city.placeholderActive' : 'pages.accountDetails.address.city.placeholderDefault') | i18n"
                              formControlName="city"
                              [disabled]="!isEditingAddress || !selectedState || !cities.length"
                              (input)="onCityInput($event)"
                              (focus)="onCityFocus()"
                              (keydown)="onCityKeydown($event); preventLeadingSpace($event)"
                              autocomplete="off"
                              required
                            ></umkt-custom-input>
                            <div *ngIf="cityControl?.errors?.['required'] && cityControl?.touched" class="field-error">
                              {{ 'pages.accountDetails.address.city.errorRequired' | i18n }}
                            </div>
                            <span *ngIf="cityControl?.errors?.['notInList'] && cityControl?.touched" class="field-error">
                              {{ 'pages.accountDetails.address.city.errorNotFound' | i18n }}
                            </span>
                            <div *ngIf="showCitySuggestions && filteredCities.length > 0" class="city-suggestions">
                              <div
                                *ngFor="let city of filteredCities; let i = index"
                                class="city-suggestion-item"
                                [class.selected]="i === selectedSuggestionIndex"
                                (click)="selectCity(city)"
                                (mouseenter)="selectedSuggestionIndex = i"
                              >
                                {{ city }}
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div class="container-actions">
                <!-- Botões no modo de edição do endereço -->
                  <ng-container *ngIf="isEditingAddress">
                    <button class="action-button cancel-button" (click)="cancelEditingAddress()">
                      {{ 'shared.buttons.cancel' | i18n }}
                    </button>
                    <button class="action-button save-button" (click)="saveAddressData()"
                      [disabled]="addressForm.invalid || isLoadingCEP || (cepError && !isCitySelectedFromList()) || hasAddressCharLimitError() || !hasAddressFormChanged()"
                      [ngClass]="{'disabled-btn': addressForm.invalid || isLoadingCEP || (cepError && !isCitySelectedFromList()) || hasAddressCharLimitError() || !hasAddressFormChanged()}">
                      {{ 'shared.buttons.save' | i18n }}
                    </button>
                  </ng-container>

                <!-- Botão no modo normal -->
                  <ng-container *ngIf="!isEditingAddress">
                    <button class="action-button address-button" (click)="startEditingAddress()">
                      {{ 'pages.accountDetails.actions.updateAddress' | i18n }}
                    </button>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          
        <!-- Container 3: Alteração de senha (mostrar apenas quando isChangingPassword for true) -->
          <div class="info-container" *ngIf="isChangingPassword">
            <div class="form-container">
              <div class="form-header">
                <h2 class="form-title">{{ 'pages.accountDetails.password.title' | i18n }}</h2>
              </div>
              
              <div class="form-content">
                <form [formGroup]="changePasswordForm" class="info-form">
                  <div class="form-vertical">
                    <div class="form-field">
                      <div class="input-group">
                        <umkt-custom-input
                          formControlName="currentPassword"
                          [ariaLabel]="'pages.accountDetails.password.current.label' | i18n"
                          [placeholder]="'pages.accountDetails.password.current.placeholder' | i18n"
                          type="password"
                          [showPasswordToggle]="true"
                          [showClearButton]="false">
                        </umkt-custom-input>
                        <div *ngIf="currentPasswordControl?.errors?.['required'] && currentPasswordControl?.touched" class="field-error">
                          {{ 'pages.accountDetails.password.current.errorRequired' | i18n }}
                        </div>
                      </div>
                    </div>
                    
                    <div class="form-field">
                      <div class="input-group">
                        <umkt-custom-input
                          #newPasswordInput
                          formControlName="newPassword"
                          [ariaLabel]="'pages.accountDetails.password.new.label' | i18n"
                          [placeholder]="'pages.accountDetails.password.new.placeholder' | i18n"
                          type="password"
                          [maxlength]="256"
                          [showPasswordToggle]="true"
                          [showClearButton]="false"
                          (keydown)="preventSpace($event)"
                          (paste)="preventSpacePaste($event)"
                          (passwordToggle)="onPasswordToggle($event)">
                        </umkt-custom-input>
                        <div *ngIf="newPasswordControl?.value?.length > 255" class="field-error">{{ 'pages.accountDetails.password.new.errorMax' | i18n }}</div>
                        <div *ngIf="newPasswordControl?.value?.length <= 255 && newPasswordControl?.errors?.['required'] && newPasswordControl?.touched" class="field-error">
                          {{ 'pages.accountDetails.password.new.errorRequired' | i18n }}
                        </div>
                        <div *ngIf="newPasswordControl?.value?.length <= 255 && !newPasswordControl?.errors?.['required'] && newPasswordControl?.errors?.['invalidPassword'] && newPasswordControl?.touched" class="field-error">
                          {{ 'pages.accountDetails.password.new.errorInvalid' | i18n }}
                        </div>
                      </div>
                    </div>
                    
                    <div class="form-field">
                      <div class="input-group">
                        <umkt-custom-input
                          #confirmPasswordInput
                          formControlName="confirmPassword"
                          [ariaLabel]="'pages.accountDetails.password.confirm.label' | i18n"
                          [placeholder]="'pages.accountDetails.password.confirm.placeholder' | i18n"
                          type="password"
                          [maxlength]="256"
                          [showClearButton]="false"
                          [showPasswordToggle]="true"
                          (keydown)="preventSpace($event)"
                          (paste)="preventSpacePaste($event)"
                          (passwordToggle)="onPasswordToggle($event)">
                        </umkt-custom-input>
                        <div *ngIf="confirmNewPasswordControl?.errors?.['required'] && confirmNewPasswordControl?.touched" class="field-error">
                          {{ 'pages.accountDetails.password.confirm.errorRequired' | i18n }}
                        </div>
                        <div *ngIf="changePasswordForm?.errors?.['passwordMismatch'] && confirmNewPasswordControl?.touched" class="field-error">
                          {{ 'pages.accountDetails.password.confirm.errorMismatch' | i18n }}
                        </div>
                      </div>
                    </div>
                    <div class="form-field">
                      <umkt-password-requirements [requirements]="passwordRequirements" [isPristine]="!newPasswordControl.dirty"></umkt-password-requirements>
                    </div>
                  </div>
                </form>

              <!-- Botões de ação (mostrar apenas quando editando) -->
                <div *ngIf="isChangingPassword" class="container-actions">
                  <button class="action-button cancel-button" (click)="cancelChangingPassword()">
                    {{ 'shared.buttons.cancel' | i18n }}
                  </button>
                  <button class="action-button save-button" (click)="updatePassword()"
                    [disabled]="changePasswordForm.invalid"
                    [ngClass]="{'disabled-btn': changePasswordForm.invalid}">
                    {{ 'shared.buttons.save' | i18n }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #errorBlock>
      <umkt-error-display
        [retryCount]="retryCount"
        (retry)="handleRetry()">
      </umkt-error-display>
    </ng-template>
  </ng-container>
</div>
